/**
 * @module
 * @format
 */

import {CONST, OBJECT, STRING, OPTIONAL} from '@acng/frontend-rubicon';
/**
 * @import {Valid} from '@acng/frontend-rubicon';
 */
import {TIMESTAMP_MS} from './time.js';
import {asAmateurIs} from './amateur.js';

const $creator = 'creator';

const asCreatorUpdate = /* @__PURE__ */ OBJECT({
  id: STRING,
  is: /* @__PURE__ */ OPTIONAL(asAmateurIs),
});

/**
 * @typedef {Valid<asCreatorUpdate>} CreatorUpdate
 */

const asCreatorUpdateEvent = /* @__PURE__ */ OBJECT({
  type: /* @__PURE__ */ CONST($creator),
  timestamp_ms: TIMESTAMP_MS,
  creator: asCreatorUpdate,
});

export {
  //
  $creator,
  asCreatorUpdateEvent,
};
